export const STORE_PLACEHOLDER_URL = "#coming-soon";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=ro.meetingsapp.meetings";
export const APP_STORE_URL = null; // not live yet
export const WHATSAPP_URL = "https://wa.me/40734968672";
export const SITE_URL = "https://meetings-ro.app";
export const OG_IMAGE_URL = `${SITE_URL}/assets/branding/og-image.png`;
export const BRAND_LOGO_PATH = "/assets/branding/meetings-logo.svg";
export const HERO_VIDEO_PATH = "/assets/hero/hero-loop.mp4";
export const HERO_POSTER_PATH = "/assets/hero/hero-poster.jpg";

export const landingContent = {
  ro: {
    locale: "ro_RO",
    meta: {
      title: "Meetings.ro — Proces verbal automat din orice înregistrare",
      description:
        "Transformă orice înregistrare audio într-un proces verbal structurat, gata de semnat. Diarizare pe vorbitori, export PDF și DOCX.",
      keywords: [
        "proces verbal automat",
        "diarizare automata",
        "minuta sedinta",
        "transcriere romana",
        "software primarie",
        "raport sedinta consiliu local",
        "transcriere interviuri",
      ],
    },
    navigation: {
      features: "Funcționalități",
      structure: "Raportul",
      pricing: "Prețuri",
      security: "Confidențialitate",
      faq: "Întrebări",
      download: "Descarcă",
      openMenu: "Deschide meniul",
    },
    store: {
      tooltip: "Descarcă din Google Play",
      label: "Descarcă aplicația",
      altAppStore: "Descarcă Meetings.ro din App Store",
      altPlayStore: "Descarcă Meetings.ro din Google Play",
    },
    hero: {
      eyebrow: "Proces verbal automat din orice înregistrare",
      title: "Înregistrezi. Noi scriem raportul.",
      lead: "Orice ședință devine un proces verbal structurat, gata de semnat. În câteva minute.",
      secondaryCta: "Vezi ce conține raportul",
      trustLine: "Identificăm automat cine a vorbit. Tu doar verifici și semnezi.",
      proofs: [
        { value: "Proces verbal", label: "Structurat conform standardelor instituțiilor publice." },
        { value: "Pe vorbitori", label: "Diarizare automată. Fiecare replică, atribuită corect." },
        { value: "PDF & DOCX", label: "Export gata de trimis. Fără editare manuală." },
      ],
    },
    problem: {
      eyebrow: "De la audio la document",
      title: "Gata cu orele de transcriere manuală.",
      lead: "Înregistrezi sau încarci un fișier. Restul se face automat.",
      body:
        "Înregistrează ședința direct din aplicație sau încarcă un fișier audio existent. Orice durată, orice format. Primești înapoi un proces verbal complet.",
      calloutTitle: "Înregistrezi sau încarci",
      calloutBody:
        "Orice durată, orice format. Înregistrarea audio se șterge automat după procesare.",
      calloutBadge: "Automat, în câțiva pași",
      steps: [
        "1. Înregistrezi ședința sau încarci fișierul audio.",
        "2. Identificăm vorbitorii și structurăm discuția.",
        "3. Primești procesul verbal, gata de export.",
      ],
    },
    fields: {
      eyebrow: "Ce conține fiecare raport",
      title: "Un proces verbal complet.",
      lead: "Fiecare raport vine structurat. Verifici, exporți, arhivezi.",
      statement: "Nu primești text brut. Primești un document oficial.",
      items: [
        { label: "Participanți", description: "Lista completă, identificată automat." },
        { label: "Ordinea de zi", description: "Punctele discutate, în ordine." },
        { label: "Diarizare pe vorbitori", description: "Fiecare replică, atribuită vorbitorului corect." },
        { label: "Decizii și voturi", description: "Ce s-a hotărât și cum s-a votat." },
        { label: "Action items", description: "Cine face ce, cu responsabil și termen." },
        { label: "Concluzii", description: "Sinteza finală, ușor de verificat." },
      ],
    },
    verticals: {
      eyebrow: "Pentru orice context",
      title: "Construit pentru ședințele tale.",
      lead: "Același proces simplu. Raportul se adaptează la context.",
      cards: [
        {
          title: "Consilii locale și primării",
          subtitle: "Administrație publică locală",
          extracts: ["Proces verbal conform standardelor", "Ordinea de zi", "Decizii și voturi", "Participanți identificați"],
          useCase: "Procesul verbal al ședinței, gata înainte să pleci din sală.",
          testid: "industry-public-card",
        },
        {
          title: "Ședințe corporative și boarduri",
          subtitle: "Companii, consilii de administrație",
          extracts: ["Minute de board", "Decizii", "Action items cu responsabili", "Concluzii"],
          useCase: "Minute de board structurate după fiecare ședință.",
          testid: "industry-corporate-card",
        },
        {
          title: "Audiențe și proceduri juridice",
          subtitle: "Avocați, tribunale, notariate",
          extracts: ["Transcriere pe vorbitori", "Declarații", "Termene și obligații", "Părți implicate"],
          useCase: "Fiecare declarație, atribuită corect și arhivată.",
          testid: "industry-legal-card",
        },
        {
          title: "Consultații medicale",
          subtitle: "Cabinete, clinici, spitale",
          extracts: ["Note de consultație", "Recomandări", "Diagnostic discutat", "Pași următori"],
          useCase: "Consultația, transcrisă și structurată în minute.",
          testid: "industry-medical-card",
        },
        {
          title: "Interviuri și podcasturi",
          subtitle: "Jurnaliști, creatori de conținut",
          extracts: ["Citate directe", "Vorbitori identificați", "Subiecte principale", "Sinteză"],
          useCase: "De la interviu la transcriere structurată, rapid.",
          testid: "industry-media-card",
        },
        {
          title: "Înregistrări personale",
          subtitle: "Note, idei, memo-uri vocale",
          extracts: ["Transcriere clară", "Idei principale", "Pași următori", "Rezumat"],
          useCase: "Memo-urile vocale, transformate în text structurat.",
          testid: "industry-personal-card",
        },
      ],
    },
    features: {
      eyebrow: "Cum funcționează",
      title: "Trei lucruri pe care le facem automat.",
      lead: "Tu înregistrezi. Noi structurăm.",
      cards: [
        {
          title: "Diarizare automată",
          description: "Identificăm cine a vorbit și când. Fiecare replică, atribuită corect.",
          detail: "Ion Popescu, Maria Ionescu sau Vorbitor 1, 2, 3.",
          testid: "feature-diarization-card",
        },
        {
          title: "Proces verbal automat",
          description: "Structurat conform standardelor instituțiilor publice românești.",
          detail: "Consilii, primării, tribunale, spitale, universități.",
          testid: "feature-minutes-card",
        },
        {
          title: "Export PDF și DOCX",
          description: "Descarci raportul gata formatat, în Word sau PDF.",
          detail: "Îl trimiți colegilor fără editare suplimentară.",
          testid: "feature-export-card",
        },
      ],
    },
    security: {
      eyebrow: "Date securizate",
      title: "Datele tale rămân ale tale.",
      lead: "Securitate reală, nu doar promisiuni.",
      bullets: [
        "Înregistrările audio sunt șterse automat după procesare.",
        "Transcrierea rămâne în contul tău, privat.",
        "Conform GDPR.",
        "Suport în limba română.",
      ],
      badges: ["GDPR", "Audio șters automat", "Suport română"],
      cardTitle: "Construit în România. Pentru România.",
      cardLead: "Standarde de instituție publică, fără complicații.",
      cardItems: [
        "Proces verbal conform standardelor românești",
        "Interfață simplă, fără training",
        "Dezvoltat de NEDEROV COMEX SRL",
      ],
    },
    pricing: {
      eyebrow: "Prețuri în EUR",
      title: "Simplu. Fără surprize.",
      lead: "Trei planuri. Alegi ce ți se potrivește.",
      toggleMonthly: "Lunar",
      toggleAnnual: "Anual",
      savingsLabel: "Economisești cu plata anuală",
      vatNote: "Prețuri fără TVA",
      plans: [
        {
          name: "Starter",
          badge: "Gratuit",
          monthlyPrice: "0€",
          annualPrice: "0€",
          monthlyPeriod: "/lună",
          annualPeriod: "/an",
          detail: "15 minute / lună",
          features: ["Înregistrare și upload", "Diarizare pe vorbitori", "Proces verbal automat", "Export PDF"],
          ctaLabel: "Descarcă gratuit",
          ctaType: "store-badges",
          highlight: false,
          badgeTone: "neutral",
          testid: "pricing-starter-card",
        },
        {
          name: "Pro",
          badge: "Cel mai popular",
          monthlyPrice: "19€",
          annualPrice: "182€",
          monthlyPeriod: "/lună",
          annualPeriod: "/an",
          detail: "5 ore (300 min) / lună",
          features: ["Tot din Starter", "Export PDF și DOCX", "Istoric și căutare", "Suport prioritar"],
          ctaLabel: "Alege Pro",
          ctaType: "store-badges",
          highlight: true,
          badgeTone: "featured",
          testid: "pricing-pro-card",
        },
        {
          name: "Enterprise",
          badge: "Enterprise",
          monthlyPrice: "99€",
          annualPrice: "950€",
          monthlyPeriod: "/lună",
          annualPeriod: "/an",
          detail: "Utilizare nelimitată",
          features: ["Tot din Pro", "Onboarding dedicat", "Factură fiscală", "SLA și suport dedicat"],
          ctaLabel: "Contactează-ne",
          ctaType: "contact",
          ctaHref: "mailto:support@meetings-ro.app",
          highlight: false,
          badgeTone: "enterprise",
          testid: "pricing-enterprise-card",
        },
      ],
    },
    faq: {
      eyebrow: "Întrebări frecvente",
      title: "Răspunsuri scurte. Fără jargon.",
      lead: "Ce trebuie să știi înainte să începi.",
      items: [
        {
          question: "Cum identifică cine a vorbit?",
          answer: "Automat. Diarizăm înregistrarea și atribuim fiecare replică vorbitorului corect.",
          testid: "faq-item-diarization",
        },
        {
          question: "Ce conține procesul verbal?",
          answer: "Participanți, ordinea de zi, decizii și voturi, action items cu responsabili și termene, concluzii — conform standardelor instituțiilor publice.",
          testid: "faq-item-minutes",
        },
        {
          question: "Pot încărca un fișier audio existent?",
          answer: "Da. Înregistrezi din aplicație sau încarci un fișier. Orice durată, orice format.",
          testid: "faq-item-upload",
        },
        {
          question: "Ce se întâmplă cu înregistrarea audio?",
          answer: "Se șterge automat după procesare. Rămâne doar transcrierea, în contul tău.",
          testid: "faq-item-security",
        },
        {
          question: "Pot exporta în Word și PDF?",
          answer: "Da. Un click și descarci PDF sau DOCX, gata de trimis.",
          testid: "faq-item-export",
        },
        {
          question: "Pentru ce tipuri de ședințe e potrivit?",
          answer: "Consilii locale, ședințe corporative, audiențe juridice, consultații medicale, interviuri și înregistrări personale.",
          testid: "faq-item-verticals",
        },
      ],
    },
    finalCta: {
      title: "Mai puțin scris. Mai mult timp pentru decizii.",
      lead: "Descarcă Meetings.ro și primești procesul verbal automat.",
      secondary: "Vezi prețurile",
    },
    testimonials: {
      eyebrow: "Dezvoltat în România de NEDEROV COMEX SRL",
      clients: [],
    },
    footer: {
      statement: "Meetings.ro — proces verbal structurat din orice înregistrare.",
      support: "Suport în română • GDPR • Creat pentru instituții",
      copyright: "© 2026 NEDEROV COMEX S.R.L. Toate drepturile rezervate. CUI: 46076724",
      links: [
        { label: "Termeni și condiții", href: "/terms", internal: true },
        { label: "Politică confidențialitate", href: "/privacy-policy", internal: true },
        { label: "Contact", href: "mailto:support@meetings-ro.app" },
      ],
    },
    preview: {
      title: "Proces verbal generat",
      location: "Ședință de consiliu local",
      generatedAt: "Generat în ~2 minute",
      summary: "Participanți, decizii, action items și concluzii apar structurat, gata pentru verificare și semnătură.",
      tags: ["Participanți", "Ordinea de zi", "Decizii", "Concluzii"],
      sections: ["Diarizare pe vorbitori", "Decizii și voturi", "Action items"],
    },
  },
  en: {
    locale: "en_US",
    meta: {
      title: "Meetings.ro — Automatic minutes from any recording",
      description:
        "Turn any audio recording into structured minutes, ready to sign. Speaker diarization, PDF and DOCX export.",
      keywords: [
        "automatic meeting minutes",
        "speaker diarization",
        "meeting transcription",
        "public administration software",
        "council meeting report",
        "interview transcription",
        "structured report",
      ],
    },
    navigation: {
      features: "Features",
      structure: "The report",
      pricing: "Pricing",
      security: "Trust",
      faq: "FAQ",
      download: "Download",
      openMenu: "Open menu",
    },
    store: {
      tooltip: "Get it on Google Play",
      label: "Download the app",
      altAppStore: "Download Meetings.ro from the App Store",
      altPlayStore: "Download Meetings.ro from Google Play",
    },
    hero: {
      eyebrow: "Automatic minutes from any recording",
      title: "Record. We write the report.",
      lead: "Any meeting becomes structured minutes, ready to sign. In minutes.",
      secondaryCta: "See what's in the report",
      trustLine: "We identify who spoke automatically. You just review and sign.",
      proofs: [
        { value: "Minutes", label: "Structured to Romanian public-institution standards." },
        { value: "Per speaker", label: "Automatic diarization. Every line attributed correctly." },
        { value: "PDF & DOCX", label: "Export ready to send. No manual editing." },
      ],
    },
    problem: {
      eyebrow: "From audio to document",
      title: "No more hours of manual transcription.",
      lead: "Record or upload a file. The rest is automatic.",
      body:
        "Record the meeting in the app or upload an existing audio file. Any duration, any format. You get back complete minutes.",
      calloutTitle: "Record or upload",
      calloutBody:
        "Any duration, any format. The audio recording is deleted automatically after processing.",
      calloutBadge: "Automatic, in a few steps",
      steps: [
        "1. Record the meeting or upload the audio file.",
        "2. We identify speakers and structure the discussion.",
        "3. You get the minutes, ready to export.",
      ],
    },
    fields: {
      eyebrow: "What's in every report",
      title: "Complete minutes.",
      lead: "Every report comes structured. Review, export, archive.",
      statement: "Not raw text. A proper official document.",
      items: [
        { label: "Attendees", description: "Full list, identified automatically." },
        { label: "Agenda", description: "Topics discussed, in order." },
        { label: "Speaker diarization", description: "Every line attributed to the right speaker." },
        { label: "Decisions & votes", description: "What was decided and how it was voted." },
        { label: "Action items", description: "Who does what, with owner and deadline." },
        { label: "Conclusions", description: "Final summary, easy to verify." },
      ],
    },
    verticals: {
      eyebrow: "For any context",
      title: "Built for your meetings.",
      lead: "Same simple process. The report adapts to the context.",
      cards: [
        {
          title: "Local councils & city halls",
          subtitle: "Local public administration",
          extracts: ["Standards-compliant minutes", "Agenda", "Decisions & votes", "Identified attendees"],
          useCase: "Meeting minutes ready before you leave the room.",
          testid: "industry-public-card",
        },
        {
          title: "Corporate meetings & boards",
          subtitle: "Companies, boards of directors",
          extracts: ["Board minutes", "Decisions", "Action items with owners", "Conclusions"],
          useCase: "Structured board minutes after every meeting.",
          testid: "industry-corporate-card",
        },
        {
          title: "Legal hearings & proceedings",
          subtitle: "Lawyers, courts, notaries",
          extracts: ["Speaker transcription", "Statements", "Deadlines & obligations", "Parties involved"],
          useCase: "Every statement, attributed correctly and archived.",
          testid: "industry-legal-card",
        },
        {
          title: "Medical consultations",
          subtitle: "Practices, clinics, hospitals",
          extracts: ["Consultation notes", "Recommendations", "Discussed diagnosis", "Next steps"],
          useCase: "The consultation, transcribed and structured in minutes.",
          testid: "industry-medical-card",
        },
        {
          title: "Interviews & podcasts",
          subtitle: "Journalists, content creators",
          extracts: ["Direct quotes", "Identified speakers", "Main topics", "Summary"],
          useCase: "From interview to structured transcript, fast.",
          testid: "industry-media-card",
        },
        {
          title: "Personal recordings",
          subtitle: "Notes, ideas, voice memos",
          extracts: ["Clear transcription", "Key ideas", "Next steps", "Summary"],
          useCase: "Voice memos turned into structured text.",
          testid: "industry-personal-card",
        },
      ],
    },
    features: {
      eyebrow: "How it works",
      title: "Three things we do automatically.",
      lead: "You record. We structure.",
      cards: [
        {
          title: "Automatic diarization",
          description: "We identify who spoke and when. Each line attributed correctly.",
          detail: "Ion Popescu, Maria Ionescu or Speaker 1, 2, 3.",
          testid: "feature-diarization-card",
        },
        {
          title: "Automatic minutes",
          description: "Structured to the standards of Romanian public institutions.",
          detail: "Councils, city halls, courts, hospitals, universities.",
          testid: "feature-minutes-card",
        },
        {
          title: "PDF & DOCX export",
          description: "Download the ready-formatted report in Word or PDF.",
          detail: "Send it to colleagues with no extra editing.",
          testid: "feature-export-card",
        },
      ],
    },
    security: {
      eyebrow: "Secured data",
      title: "Your data stays yours.",
      lead: "Real security, not just promises.",
      bullets: [
        "Audio recordings are deleted automatically after processing.",
        "The transcript stays in your account, private.",
        "GDPR compliant.",
        "Romanian-language support.",
      ],
      badges: ["GDPR", "Audio auto-deleted", "Romanian support"],
      cardTitle: "Built in Romania. For Romania.",
      cardLead: "Public-institution standards, without the complexity.",
      cardItems: [
        "Minutes to Romanian standards",
        "Simple interface, no training",
        "Developed by NEDEROV COMEX SRL",
      ],
    },
    pricing: {
      eyebrow: "Pricing in EUR",
      title: "Simple. No surprises.",
      lead: "Three plans. Pick what fits.",
      toggleMonthly: "Monthly",
      toggleAnnual: "Annual",
      savingsLabel: "Save with annual billing",
      vatNote: "Prices exclude VAT",
      plans: [
        {
          name: "Starter",
          badge: "Free",
          monthlyPrice: "0€",
          annualPrice: "0€",
          monthlyPeriod: "/month",
          annualPeriod: "/year",
          detail: "15 minutes / month",
          features: ["Record and upload", "Speaker diarization", "Automatic minutes", "PDF export"],
          ctaLabel: "Download free",
          ctaType: "store-badges",
          highlight: false,
          badgeTone: "neutral",
          testid: "pricing-starter-card",
        },
        {
          name: "Pro",
          badge: "Most popular",
          monthlyPrice: "19€",
          annualPrice: "182€",
          monthlyPeriod: "/month",
          annualPeriod: "/year",
          detail: "5 hours (300 min) / month",
          features: ["Everything in Starter", "PDF and DOCX export", "History and search", "Priority support"],
          ctaLabel: "Choose Pro",
          ctaType: "store-badges",
          highlight: true,
          badgeTone: "featured",
          testid: "pricing-pro-card",
        },
        {
          name: "Enterprise",
          badge: "Enterprise",
          monthlyPrice: "99€",
          annualPrice: "950€",
          monthlyPeriod: "/month",
          annualPeriod: "/year",
          detail: "Unlimited use",
          features: ["Everything in Pro", "Dedicated onboarding", "Tax invoice", "SLA and dedicated support"],
          ctaLabel: "Contact us",
          ctaType: "contact",
          ctaHref: "mailto:support@meetings-ro.app",
          highlight: false,
          badgeTone: "enterprise",
          testid: "pricing-enterprise-card",
        },
      ],
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "Short answers. No jargon.",
      lead: "What you need to know before starting.",
      items: [
        {
          question: "How does it identify who spoke?",
          answer: "Automatically. We diarize the recording and attribute each line to the right speaker.",
          testid: "faq-item-diarization",
        },
        {
          question: "What's in the minutes?",
          answer: "Attendees, agenda, decisions and votes, action items with owners and deadlines, conclusions — to public-institution standards.",
          testid: "faq-item-minutes",
        },
        {
          question: "Can I upload an existing audio file?",
          answer: "Yes. Record in the app or upload a file. Any duration, any format.",
          testid: "faq-item-upload",
        },
        {
          question: "What happens to the audio recording?",
          answer: "It's deleted automatically after processing. Only the transcript remains, in your account.",
          testid: "faq-item-security",
        },
        {
          question: "Can I export to Word and PDF?",
          answer: "Yes. One click and you download PDF or DOCX, ready to send.",
          testid: "faq-item-export",
        },
        {
          question: "What meetings is it good for?",
          answer: "Local councils, corporate meetings, legal hearings, medical consultations, interviews and personal recordings.",
          testid: "faq-item-verticals",
        },
      ],
    },
    finalCta: {
      title: "Less writing. More time for decisions.",
      lead: "Download Meetings.ro and get your minutes automatically.",
      secondary: "See pricing",
    },
    testimonials: {
      eyebrow: "Built in Romania by NEDEROV COMEX SRL",
      clients: [],
    },
    footer: {
      statement: "Meetings.ro — structured minutes from any recording.",
      support: "Romanian support • GDPR • Built for institutions",
      copyright: "© 2026 NEDEROV COMEX S.R.L. Toate drepturile rezervate. CUI: 46076724",
      links: [
        { label: "Terms & Conditions", href: "/terms", internal: true },
        { label: "Privacy Policy", href: "/privacy-policy", internal: true },
        { label: "Contact", href: "mailto:support@meetings-ro.app" },
      ],
    },
    preview: {
      title: "Generated minutes",
      location: "Local council meeting",
      generatedAt: "Generated in ~2 minutes",
      summary: "Attendees, decisions, action items and conclusions appear structured, ready for review and signature.",
      tags: ["Attendees", "Agenda", "Decisions", "Conclusions"],
      sections: ["Speaker diarization", "Decisions & votes", "Action items"],
    },
  },
};
